import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import {
  Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle,
} from '@/components/ui/empty';

/**
 * The ONE empty state (kit pattern "empty-states/01").
 *
 * build/10 §5 requires every data surface to have skeleton, empty, and error
 * states. This is the empty one — used for an unseeded item bank, a module
 * list before anything is authored, a matrix with no cells, and so on.
 *
 * Screens compose this rather than inventing their own blank slate, so "no
 * data yet" looks identical everywhere.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  actions,
  className,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <Empty className={className ?? 'border-border rounded-xl border border-dashed py-16'}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon />
        </EmptyMedia>
        <EmptyTitle className="text-xl">{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {actions && (
        <EmptyContent className="flex-row justify-center gap-2">{actions}</EmptyContent>
      )}
    </Empty>
  );
}
